import axios from 'axios';
import qs from 'qs';

export default async function createRequest() {
  const stackName = STACK_NAME || 'staging';

  return axios.create({
    baseURL:
      stackName === 'prod'
        ? `https://valuations-api.whatcar.com`
        : `https://valuations-api.whatcardev.haymarket.com/${stackName}`,
    paramsSerializer: params => {
      return qs.stringify(params);
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js